<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Van was born in 1950; did his national service in Pretoria; worked at Western Province Sports Club for eighteen years and began travelling in the late eighties; back packing through Asia and Western Europe. Finally settling in Britain where he began writing.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?1f647390